export const URL_MAX_LENGTH = 200;
export const MAX_URLS_PER_PROJECT = 100;
//# sourceMappingURL=api-errors-additional-data-url.model.js.map